export class Plan {
    PlanName: string;
    Family: string;
    Size: number;
    Suffix: string | null;
    PlanID: number;
    BidSetURL?:string;
    RenderURL?:string;
    PlanSPID: number;
    Available: boolean;
    Archived: boolean;
    Collection: string;
    StyleID: number;
    Floors: number;
    Garage: boolean;
    Thumb: string;
    MarkedForDelete: boolean;
    studioDocId: string | null;
    familyId: number | null;
    customPlan?: boolean | null;
    planFamilies?: PlanFamily;
    Styles?: PlanStyle;
    PlanPrices?: PlanPricing[];
    OfficePlans?: PlanOffice[];
    PlanFiles?: haPlanFiles[];

    constructor() {
    this.PlanName = '' ;
    this.Family = '' ;
    this.Size = 0 ;
    this.Suffix = '' ;
    this.PlanID = 0 ;
    this.PlanSPID = 0 ;
    this.Available = false ;
    this.Archived = false;
    this.Collection = '';
    this.StyleID = 0 ;
    this.studioDocId = null;
    this.Floors = 0 ;
    this.Garage = false ;
    this.Thumb = '' ;
    this.MarkedForDelete = false ;
    this.familyId = null;
    }
}

export interface PlanOffice {
    FID: number;
    PlanID: number;
    Franchise?: {
        CityCode: string;
    }
}

export interface haPlanFiles {
    studioDocId: string;
    planId: number;
    haPlanDocId: number;
}

export interface PlanFamily {
    familyId: number;
    Family: string;
}

export interface PlanStyle {
    StyleName: string;
    StyleID: number;
    haPlanStyles: HigharcPlanStyle[];
}

interface HigharcPlanStyle {
    elevationId: string;
    styleId: number;
    haStyleId: number;
}

export interface PlanPricing {
    PlanID: number,
    BasePrice: number,
    PPID: number,
    FID: number,
    ParentFID: number,
}

export interface PlanGroup { 
    Family: string, 
    Plans: Plan[] 
}

export interface SSPlan {
    PlanID: number,
      SSID: number,
      FID: number,
      SSPlanID: number,
      ParentFID: number,
      Plans: {
        PlanName: string,
        Styles: PlanStyle
      }
}